import ResizableModal from '@components/ResiableModal'
import { ApiService } from '@services/ApiService'
import React, { useEffect, useState } from 'react'

interface PDFViewerModalProps {
  open: boolean
  onClose: () => void
  fileId: string
  fileName: string
}

const PDFViewerModal: React.FC<PDFViewerModalProps> = ({
  open,
  onClose,
  fileId,
  fileName,
}) => {
  const [loading, setLoading] = useState(false)
  const [blobUrl, setBlobUrl] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (open && fileId) {
      loadPDFFile()
    }

    return () => {
      // Cleanup blob URL khi component unmount hoặc modal đóng
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl)
        setBlobUrl(null)
      }
    }
  }, [open, fileId])

  const loadPDFFile = async () => {
    setLoading(true)
    setError(null)

    try {
      const res = await ApiService.File.GenerateDownloadToken(fileId)
      const accessToken = res.data
      const downloadUrl =
        process.env.VITE_API_URL +
        `/api/app/files/download?accessToken=${accessToken}`

      // Tải file về dưới dạng blob
      const response = await fetch(downloadUrl)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const blob = await response.blob()
      const url = URL.createObjectURL(blob)
      setBlobUrl(url)
    } catch (err) {
      console.error('Error loading PDF file:', err)
      setError('Failed to load PDF file')
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    if (blobUrl) {
      URL.revokeObjectURL(blobUrl)
      setBlobUrl(null)
    }
    setError(null)
    onClose()
  }

  return (
    <ResizableModal open={open} onCancel={handleClose} title={fileName}>
      {blobUrl && !loading && !error && (
        <iframe
          src={blobUrl}
          title={fileName}
          className="w-full h-full"
          frameBorder="0"
        />
      )}
    </ResizableModal>
  )
}

export default PDFViewerModal
